import { MaterialDesignContent } from 'notistack';
import { styled } from '@mui/material';

export const DefaultSnackbar = styled(MaterialDesignContent)(() => ({
  '& #notistack-snackbar': {
    overflow: 'hidden',
    minWidth: '180px',
    maxWidth: '300px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'block',
  },
}));
